import { ReactComponent as Icon } from "../images/eyes.svg";

const EyesIcon  = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default EyesIcon;
